<!--
검수에 사용되는 검수요청사항 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-margin-bottom">
        <!-- 검수요청사항이 없는 경우 -->
        <div
            class="uk-text-large uk-text-muted uk-text-center "
            v-show="check_requests.length === 0"
        >
            검수요청사항이 없습니다
        </div>

        <!-- 검수요청사항이 있는 경우 -->
        <div
            class="uk-card uk-card-default uk-card-small uk-width-xxlarge uk-margin-auto"
            v-show="check_requests.length > 0"
        >
            <div
                class="uk-card-header uk-text-left"
            >
                <span uk-icon="comment"></span>
                검수요청사항
            </div>

            <request-item
                v-for="(req, index) in check_requests"
                v-bind:key="req.id"
                :request="req.request"
            >
            </request-item>
        </div>
    </div>

</template>

<script>
    export default {
        components: {
            'request-item': require('./request-item.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,
        },
        data: function () {
            return {
                // 검수요청 배열
                check_requests: [],
            };
        },
        computed: {

        },
        mounted: function () {
            // 검수요청사항 조회 / 표시
            this.display();
        },
        methods: {

            /**
             * 검수요청사항 내용 표시
             */
            display() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + this.prodId + '/check-requests',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.check_requests = response.check_requests;
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>